<template>
    <div class="block sm:flex">
        <div class="mr-5 whitespace-nowrap flex items-center text-2xl">{{$t('shared.auction_visibility.title')}}</div>
        <div class="mt-3 sm:mt-0 flex cursor-pointer relative" @click="showToggleAuctionConfirmationDialog">
            <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
            <button type="button"
                    class="relative inline-flex h-9 w-24 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
                    :class="{'bg-red-500': auctionIsHidden, 'bg-green-500': !auctionIsHidden}"
                    role="switch"
                    :aria-checked="auctionIsHidden"
                    aria-labelledby="annual-billing-label">
                <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
                <span aria-hidden="true"
                      class="pointer-events-none inline-block h-8 w-8 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                      :class="{'translate-x-12 auction-visibility-spotlight' : auctionIsHidden, 'translate-x-0' : !auctionIsHidden}"
                ></span>
            </button>
            <span class="ml-3 flex items-center" id="annual-billing-label">
                <span class="text-sm font-medium text-gray-900" v-if="!auctionIsHidden">{{$t('shared.auction_visibility.visible')}}</span>
                <span class="text-sm font-medium text-gray-900" v-if="auctionIsHidden">{{$t('shared.auction_visibility.hidden')}}</span>
            </span>
            <div class="flex absolute w-24 h-9 items-center">
                <icon name="eye" class="h-6 w-6 auction-visibility-eye-visible" :class="{'text-white': auctionIsHidden, 'text-green-500': !auctionIsHidden}"/>
                <icon name="eye-strike" class="h-6 w-6 absolute auction-visibility-eye-hidden mt-1" :class="{'text-red-500': auctionIsHidden, 'text-white': !auctionIsHidden}"/>
            </div>
        </div>
        <modal ref="toggleAuctionConfirmDialog"
               @confirm="onSubmitToggleAuction"
               @cancel="onCancelToggleAuction"
               :dangerous="true"
               :title="getHideAuctionTitle">
            <span class="">{{getHideAuctionText}}</span>
            <div class="loading-indicator" v-if="sendingHideAuction">
                <icon name="clock" class="w-8 h-8 mx-auto animate-spin"/>
            </div>
            <alert-message
                v-if="showHideAuctionFailed && getHideAuctionFailedMessage && getHideAuctionFailedMessage.length > 0"
                :error-type="ERROR_TYPE_ERROR"
                :show-as-list="false"
                :messages="getHideAuctionFailedMessage"
                :display-errors-title="false"
                @close="hideAuctionFailedAlertClosed()"
                class="sm:px-0 lg:px-0 pr-4 sm:pr-6 lg:pr-4"
            />
        </modal>
    </div>
</template>


<script>
import Icon from "../Icon";
import Modal from "../Modals/Modal";
import {ErrorTypes} from '../../mixins/ErrorTypes';
import AlertMessage from "../Alerts/AlertMessage";

export default {
    props: {
        auction: Object
    },
    components: {
        Icon,
        Modal,
        AlertMessage
    },
    mixins:[
        ErrorTypes
    ],
    data() {
      return {
          sendingHideAuction: false,
          showHideAuctionFailed: false
      }
    },
    methods: {
        onSubmitToggleAuction() {
            if (this.sendingHideAuction === true) {
                return;
            }
            this.$emit('toggleAuction');
            this.sendingHideAuction = true;
            this.showHideAuctionFailed = false;

            axios.put(route('auctions.hideAuction', {auction: this.auction.id}), { // Call the server and hide/show the auction
                hidden: !this.auction.hidden
            })
                .then(() => {
                    this.$refs.toggleAuctionConfirmDialog?.hide();
                })
                .catch((err) => {
                    this.showHideAuctionFailed = true;
                    console.log(err);
                })
                .finally(() => {
                    this.sendingHideAuction = false;
                });
        },
        onCancelToggleAuction() {
            this.$refs.toggleAuctionConfirmDialog?.hide();
        },
        showToggleAuctionConfirmationDialog() {
            this.showHideAuctionFailed = false;
            this.$refs.toggleAuctionConfirmDialog?.show();
        },
        hideAuctionFailedAlertClosed() {
            this.showHideAuctionFailed = false;
        }
    },
    computed: {
        auctionIsHidden: function() {
            return this.auction.hidden;
        },
        getHideAuctionTitle: function() {
            return this.auction?.hidden ?
                this.$t('shared.auction_visibility.confirm_show.title') :
                this.$t('shared.auction_visibility.confirm_hide.title') ;
        },
        getHideAuctionText: function() {
            return this.auction?.hidden ?
                this.$t('shared.auction_visibility.confirm_show.confirm') :
                this.$t('shared.auction_visibility.confirm_hide.confirm') ;
        },
        getHideAuctionFailedMessage: function() {
            return [
                !this.auction?.hidden ?
                this.$t('shared.auction_visibility.failed.hide') :
                this.$t('shared.auction_visibility.failed.show')
            ];
        }
    }
}
</script>
